const INIT_FLAG = '__trustTestimonialStripInit';

if (!window[INIT_FLAG]) {
  window[INIT_FLAG] = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tts-scroll]');
    if (!trigger) return;

    const mode = trigger.getAttribute('data-tts-scroll');
    if (mode !== 'reviews') return;

    event.preventDefault();

    const selectorOverride = (trigger.getAttribute('data-tts-selector') || '').trim();
    const offsetExtra = parseFloat(trigger.getAttribute('data-tts-offset') || '0') || 0;

    const target = findReviewsTarget(selectorOverride);
    if (!target) {
      const href = trigger.getAttribute('href');
      if (href && href.startsWith('#')) window.location.hash = href;
      return;
    }

    const headerOffset = getHeaderOffset();
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - headerOffset - offsetExtra;

    window.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });

    focusTarget(target);
  });
}

function findReviewsTarget(selectorOverride) {
  if (selectorOverride) {
    const overrideTarget = safeQuerySelector(selectorOverride);
    if (overrideTarget) return overrideTarget;
  }

  const candidates = [
    '#judgeme_product_reviews',
    '.jdgm-widget.jdgm-review-widget',
    '.jdgm-review-widget',
    '[data-judge-me-review-widget]',
    '#shopify-product-reviews',
    '.spr-container',
    '.spr-reviews',
  ];

  for (const selector of candidates) {
    const element = document.querySelector(selector);
    if (element) return element;
  }

  return null;
}

function safeQuerySelector(selector) {
  try {
    return document.querySelector(selector);
  } catch {
    return null;
  }
}

function getHeaderOffset() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
  const value = parseFloat(raw);
  return Number.isFinite(value) ? value : 0;
}

function focusTarget(target) {
  const isNaturallyFocusable =
    target.matches('a[href], button, input, select, textarea, [tabindex]') && !target.hasAttribute('disabled');

  if (isNaturallyFocusable) {
    target.focus({ preventScroll: true });
    return;
  }

  const previousTabIndex = target.getAttribute('tabindex');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });

  window.setTimeout(() => {
    if (previousTabIndex === null) target.removeAttribute('tabindex');
    else target.setAttribute('tabindex', previousTabIndex);
  }, 1000);
}

